// /src/components/AddObserverModal.jsx
import React from "react";
import { useTranslation } from "react-i18next";

export default function AddObserverModal({ open, onClose, value, onChange, onAdd, adding }) {
  const { t } = useTranslation("common");
  if (!open) return null;
  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.35)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}
      onClick={onClose}
    >
      <div
        style={{ width: "min(92vw, 520px)", background: "#fff", borderRadius: 14, boxShadow: "0 12px 32px rgba(0,0,0,.25)", overflow: "hidden" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ background: "#00723a", color: "#fff", padding: "16px 22px", fontWeight: 800, fontSize: 20 }}>
          {t("modals.add_observer.title")}
        </div>
        <div style={{ padding: "20px 22px 22px" }}>
          <input
            type="email"
            placeholder={t("modals.add_observer.email_placeholder")}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            style={{
              width: "100%",
              padding: "12px 16px",
              fontSize: 16,
              borderRadius: 8,
              border: "1px solid #bbb",
              marginBottom: 12,
              boxSizing: "border-box"
            }}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button onClick={onClose} style={{ padding: "10px 18px", fontSize: 16, borderRadius: 8, border: "1px solid #ddd", background: "#fff", cursor: "pointer" }}>
              {t("common.cancel")}
            </button>
            <button
              onClick={onAdd}
              disabled={!value || adding}
              style={{
                padding: "10px 18px",
                fontSize: 16,
                borderRadius: 8,
                border: "none",
                background: "#00723a",
                color: "#fff",
                fontWeight: 700,
                opacity: !value || adding ? .6 : 1,
                cursor: !value || adding ? "not-allowed" : "pointer"
              }}
            >
              {t("modals.add_observer.submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
